import { render, staticRenderFns } from "./IntegrationsFormComponent.vue?vue&type=template&id=01560f74&scoped=true"
import script from "./IntegrationsFormComponent.vue?vue&type=script&lang=js"
export * from "./IntegrationsFormComponent.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsFormComponent.vue?vue&type=style&index=0&id=01560f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01560f74",
  null
  
)

export default component.exports